<batch-notification
  *ngIf="isShow"
  [header]="isISFBatchItem ? 'BATCH_LIST_STEP_PARTIAL_PLURAL_ISF' : 'BATCH_LIST_STEP_PARTIAL_PLURAL_ES'"
  hint="THERE_WAS_AN_ERROR_WHILE_UPLOADING_SOME_OF_ITEMS_IN_ERP_REPORT"
  isShowReload="true"
  isShowClose="true"
  [topHint]="paymentCountStr | translate : { count: payedBatchItems }"
  [downloadUrl]="batchItem.fileReference"
  (reload)="onReload()"
  (close)="isShow = false"
></batch-notification>
